module.exports = __webpack_public_path__ + "media/testimonials/customer-3-cbf715da.png";